/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useCallback, useContext, useState } from "react";
import { useParams } from "react-router-dom";

// create Language context for handling Language data
const LanguageContext = createContext<any | undefined>(undefined);

// create Language context provider
export const LanguageProvider = ({ children }: React.PropsWithChildren) => {
  const [lan, setLan] = useState<"en" | "ar">("ar");
  const { lang } = useParams<{ lang?: string }>(); // Fetch `lang` from URL parameters
  React.useEffect(() => {
    console.log('Language from Language context',lang);
    if (lang === "en") {
      setLan("en");
    } else {
      setLan("ar"); // Default to Arabic if `lang` is not "en"
    }
  }, [lang]);

  const setLanguage = useCallback((value: "en" | "ar") => {
    setLan(value);
    // Set language in localstorage
    localStorage.setItem("lan", JSON.stringify({ value: value }));
  }, [lan]);

  return (
    <LanguageContext.Provider value={{ lan, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => useContext(LanguageContext);
